import { BxgyTriggerType } from "@redotech/redo-discounts-common/discount/discount-db-parser";
import { RedoTextInput } from "../../../arbiter-components/input/redo-text-input";
import { RedoRadioGroup } from "../../../arbiter-components/radio/redo-radio-group";
import { Flex } from "../../../flex";
import { LabeledInput, LabelSize } from "../../../labeled-input";
import { Text } from "../../../text";
import { ProductSelection } from "../../discount-shared";
import { CollectionsPicker, ProductsPicker } from "../pickers";

export function CustomerBuysField({
  triggerType,
  setTriggerType,
  triggerQuantity,
  setTriggerQuantity,
  triggerAmount,
  setTriggerAmount,
  itemType,
  setItemType,
  products,
  setProducts,
  collections,
  setCollections,
}: {
  triggerType: BxgyTriggerType;
  setTriggerType: (value: BxgyTriggerType) => void;
  triggerQuantity: number | undefined;
  setTriggerQuantity: (value: number | undefined) => void;
  triggerAmount: number | undefined;
  setTriggerAmount: (value: number | undefined) => void;
  itemType: "products" | "collections";
  setItemType: (value: "products" | "collections") => void;
  products: ProductSelection[];
  setProducts: (products: ProductSelection[]) => void;
  collections: string[];
  setCollections: (collections: string[]) => void;
}) {
  return (
    <LabeledInput
      label={
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Customer buys
        </Text>
      }
      size={LabelSize.EXTRA_SMALL}
    >
      <Flex dir="column" gap="md">
        <RedoRadioGroup
          options={[
            { id: BxgyTriggerType.MINIMUM_QUANTITY, label: "Minimum quantity" },
            {
              id: BxgyTriggerType.MINIMUM_AMOUNT,
              label: "Minimum purchase amount",
            },
          ]}
          setValue={(value) =>
            setTriggerType(
              value as
                | typeof BxgyTriggerType.MINIMUM_QUANTITY
                | typeof BxgyTriggerType.MINIMUM_AMOUNT,
            )
          }
          value={triggerType}
        />
        {triggerType === BxgyTriggerType.MINIMUM_QUANTITY && (
          <RedoTextInput
            inputTypeHint="number"
            label="Quantity"
            placeholder="1"
            setValue={(value) => {
              setTriggerQuantity(value ? Number(value) : undefined);
            }}
            value={triggerQuantity?.toString() || ""}
          />
        )}
        {triggerType === BxgyTriggerType.MINIMUM_AMOUNT && (
          <RedoTextInput
            inputTypeHint="number"
            label="Amount ($)"
            placeholder="0"
            setValue={(value) => {
              setTriggerAmount(value ? Number(value) : undefined);
            }}
            value={triggerAmount?.toString() || ""}
          />
        )}
        <Flex dir="column" gap="xs">
          <Text fontSize="xs" fontWeight="medium" textColor="secondary">
            From
          </Text>
          <RedoRadioGroup
            options={[
              { id: "products", label: "Specific products" },
              { id: "collections", label: "Collections" },
            ]}
            setValue={(value) =>
              setItemType(value as "products" | "collections")
            }
            value={itemType}
          />
          {itemType === "products" && (
            <ProductsPicker products={products} setProducts={setProducts} />
          )}
          {itemType === "collections" && (
            <CollectionsPicker
              collections={collections}
              setCollections={setCollections}
            />
          )}
        </Flex>
      </Flex>
    </LabeledInput>
  );
}
